'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _systemImportTransformerGlobalIdentifier = typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : typeof global !== 'undefined' ? global : {}; /**
                                                                                                                                                                           * Created by sidchik on 05.04.17.
                                                                                                                                                                           */

//import { hasScope, userInGroup } from '../src/helpers/access';

//import ConfigureCRUD from 'components/CRUD'

exports.default = function (_ref) {
  var appId = _ref.appId,
      formServiceUrl = _ref.formServiceUrl,
      statuses = _ref.statuses,
      auth = _ref.auth;

  // eslint-disable-next-line no-new
  new _perxUikit2.default({
    historyType: 'hash',
    appReducers: appReducers,
    // logo: './static/images/logo.png',
    defaultPath: '/',
    modules: [{
      title: 'Макеты форм',
      icon: 'layout',
      path: '^/schemas/',
      getComponent: function getComponent() {
        return typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new _promise2.default(function (resolve, reject) {
          _systemImportTransformerGlobalIdentifier.require(['components/Schemas'], resolve, reject);
        }) : typeof module !== 'undefined' && module.exports && typeof require !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('../components/Schemas'));
          });
        }) : _promise2.default.resolve(_systemImportTransformerGlobalIdentifier['components/Schemas']);
      }
    }, {
      title: 'Формы',
      icon: 'solution',
      path: '^/forms/',
      getComponent: function getComponent() {
        return typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new _promise2.default(function (resolve, reject) {
          _systemImportTransformerGlobalIdentifier.require(['components/Forms'], resolve, reject);
        }) : typeof module !== 'undefined' && module.exports && typeof require !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('../components/Forms'));
          });
        }) : _promise2.default.resolve(_systemImportTransformerGlobalIdentifier['components/Forms']);
      }
    }, {
      title: 'Получатели',
      icon: 'mail',
      path: '^/hooks/',
      getComponent: function getComponent() {
        return typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new _promise2.default(function (resolve, reject) {
          _systemImportTransformerGlobalIdentifier.require(['components/Hooks'], resolve, reject);
        }) : typeof module !== 'undefined' && module.exports && typeof require !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('../components/Hooks'));
          });
        }) : _promise2.default.resolve(_systemImportTransformerGlobalIdentifier['components/Hooks']);
      }
    }, {
      title: 'Источники данных',
      icon: 'database',
      path: '^/datasources/',
      getComponent: function getComponent() {
        return typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new _promise2.default(function (resolve, reject) {
          _systemImportTransformerGlobalIdentifier.require(['components/Datasources'], resolve, reject);
        }) : typeof module !== 'undefined' && module.exports && typeof require !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('../components/Datasources'));
          });
        }) : _promise2.default.resolve(_systemImportTransformerGlobalIdentifier['components/Datasources']);
      }
    }, {
      title: 'Заявки',
      icon: 'inbox',
      path: '^/formdata/',
      exportFormats: ['xlsx'],
      getComponent: function getComponent() {
        return typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new _promise2.default(function (resolve, reject) {
          _systemImportTransformerGlobalIdentifier.require(['components/FormData'], resolve, reject);
        }) : typeof module !== 'undefined' && module.exports && typeof require !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('../components/FormData'));
          });
        }) : _promise2.default.resolve(_systemImportTransformerGlobalIdentifier['components/FormData']);
      }
    }],
    appId: appId,
    formServiceUrl: formServiceUrl,
    statuses: statuses,
    auth: auth
  });
};

var _perxUikit = require('perx-uikit');

var _perxUikit2 = _interopRequireDefault(_perxUikit);

var _reducers = require('../data/reducers.js');

var appReducers = _interopRequireWildcard(_reducers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/entrypoints/config.js
// module id = 725
// module chunks = 5